import React, { useState, useRef, useEffect } from "react";
import GlassSlider from "../../Components/Slider";
import PitchImage from "../../Asserts/images/pitch_img.svg";
import arrowBack from "../../Asserts/images/arrow_back.svg";
import Filter from "../../Asserts/images/Filter.svg";
import DownloadIcon from "../../Asserts/images/download-white.svg";
import axios from "axios";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";

const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Data fetching...</div>
  </div>
);

const FilterDropDown = [
  { id: 1, title: "all", label: "All" },
  { id: 2, title: "active", label: "Active" },
  { id: 3, title: "in_active", label: "In Active" },
];

const COLOR_RATING = [
  {
    id: 1,
    colorCode: '#2C5626',
    textColor: "#FFFFFF",
    lable: 1
  },
  {
    id: 2,
    colorCode: '#00FF86',
    textColor: "#000000",
    lable: 2
  },
  {
    id: 3,
    colorCode: '#E7E7E7',
    textColor: "#000000",
    lable: 3
  },
  {
    id: 4,
    colorCode: '#F1003A',
    textColor: "#FFFFFF",
    lable: 4
  },
  {
    id: 5,
    colorCode: '#8F0025',
    textColor: "#FFFFFF",
    lable: 5
  },
]

function DifficultyRating({
  active,
  allOtherPlayerData,
  setSelected,
  otherPlayersPrediction,
  pickId,
  currentMatchWeek,
  seasonId,
}) {
  const [isDifficultyPickLodding, setIsDifficultyPickLodding] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const dropdownRef = useRef(null);
  const [startIndex, setStartIndex] = useState(0);
  const endIndex = otherPlayersPrediction?.end_matchweek || 0;

  const [visibleMWCount, setVisibleMWCount] = useState(getVisibleCount());

  const [difficultyMatchInfo, setDifficultyMatchInfo] = useState({
    matchweeksDates: [],
    matchweeksHeader: [],
    pagination: {},
    season: {},
    teams: [],
  });

  const totalMW = difficultyMatchInfo.season?.total_matchweeks || 0;

  const [currentPagination, setCurrentPagination] = useState({
    currentPage: currentMatchWeek,
    seasonId: seasonId
  })

  const fetchDifficultyRating = async () => {
    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.get(
        `${baseURL}/pot/difficulty-ratings/?season_id=${Number(currentPagination.seasonId)}&start_matchweek=${currentPagination.currentPage}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      // const res = await axios.get(
      //   `https://sportspick-zkvkz.ondigitalocean.app/api/pot/difficulty-ratings?season_id=340&start_matchweek=${currentPagination.currentPage}`,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${JSON.parse(token)}`,
      //     },
      //   }
      // );
      setDifficultyMatchInfo((prev) => ({
        ...prev,
        matchweeksDates: res?.data?.matchweeks_dates,
        matchweeksHeader: res?.data?.matchweeks_header,
        pagination: res?.data?.pagination,
        season: res?.data?.season,
        teams: res?.data.teams,
      }));
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2();
      }
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDifficultyRating();
  }, [currentPagination]);

  function getVisibleCount() {
    if (window.innerWidth >= 1024) return 3;
    if (window.innerWidth >= 768) return 3;
    return 3;
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef.current?.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handlePrev = (previousStart) => {
    setCurrentPagination((prev) => ({
      ...prev,
      currentPage: previousStart
    }))
    setStartIndex(previousStart);
  };

  const handleNext = (nextStart) => {
    setStartIndex(nextStart)
    setCurrentPagination((prev) => ({
      ...prev,
      currentPage: nextStart
    }))
  };

  // Create an array starting from currentMatchWeek up to totalMW
  const headerVal = Array.from({ length: totalMW }, (_, i) => i + 1);

  useEffect(() => {
    if (difficultyMatchInfo.season?.total_matchweeks && currentMatchWeek) {
      const maxStartIndex = difficultyMatchInfo?.season?.total_matchweeks - visibleMWCount;
      const calculatedStart = Math.max(0, Math.min(currentMatchWeek - 1, maxStartIndex));
      setStartIndex(calculatedStart);
    }
  }, [difficultyMatchInfo, currentMatchWeek, visibleMWCount]);

  let filteredData = [...(otherPlayersPrediction?.data || [])];

  // Apply filter logic (example: no actual status field in data, adjust as needed)
  if (selectedFilter === "active") {
    filteredData = filteredData.filter((p) => p?.is_active); // adjust based on your data
  } else if (selectedFilter === "in_active") {
    filteredData = filteredData.filter((p) => !p?.is_active); // adjust as needed
  }

  const selectedExists = filteredData.some((p) => p?.pick_id === pickId);
  if (!selectedExists && pickId) {
    const selectedFromFull = allOtherPlayerData?.find((p) => p?.pick_id === pickId);
    if (selectedFromFull) {
      filteredData = [selectedFromFull, ...filteredData];
    }
  }

  return (
    <div className="relative w-full overflow-auto">
      {isDifficultyPickLodding ? (
        <CircularLoader />
      ) : (
        <div className="">
          <table className="min-w-full text-sm text-left table-fixed mb-[20%]">
            <thead className="bg-[#00C05D] text-white sticky top-0 z-10">
              <tr>
                <th className="p-4 text-[16px] font-semibold w-32">
                  <div className="flex items-center gap-2">Team</div>
                </th>

                <th
                  className={`w-32 text-center ${!difficultyMatchInfo?.pagination?.has_previous
                    ? "opacity-50 pointer-events-none"
                    : ""
                    }`}
                  onClick={() => handlePrev(difficultyMatchInfo?.pagination?.previous_start)}
                >
                  <img
                    src={arrowBack}
                    alt="Prev"
                    className="mx-auto cursor-pointer h-2 w-2 min-h-[18px] min-w-[24px] sm:h-6 sm:w-6"
                  />
                </th>

                {difficultyMatchInfo?.matchweeksHeader?.map((match, i) => (
                  <th
                    key={`header-${match}`}
                    className="px-4 py-2 text-xs font-semibold text-center w-20"
                  >
                    {match}
                    <div>{difficultyMatchInfo?.matchweeksDates[i]}</div>
                  </th>
                ))}

                <th
                  className={`w-32 text-center ${!difficultyMatchInfo?.pagination?.has_next
                    ? "opacity-50 pointer-events-none"
                    : ""
                    }`}
                  onClick={() => handleNext(difficultyMatchInfo?.pagination?.next_start)}
                >
                  <img
                    src={arrowBack}
                    alt="Next"
                    className="mx-auto cursor-pointer h-2 w-2 min-h-[18px] min-w-[24px] sm:h-6 sm:w-6 rotate-180"
                  />
                </th>
              </tr>
            </thead>

            <tbody className="overflow-y-auto relative">
              {difficultyMatchInfo?.teams?.length > 0 ? (
                difficultyMatchInfo?.teams?.map((player, idx) => {
                  const teamCode = player?.team_code;
                  const matchweeks = [...player.matchweeks];
                  while (matchweeks.length < difficultyMatchInfo?.matchweeksHeader?.length) {
                    matchweeks.push(null);
                  }

                  return (
                    <tr key={idx} className="border-b">
                      <td className="px-4 py-2 font-medium text-gray-800 w-32">
                        <p className="flex gap-2">
                          <img src={player.team_logo} className="h-6 w-6" />
                          <span className="text-[#000000CC] text-[14px]">{teamCode}</span>
                        </p>

                      </td>
                      <td className="w-8"></td>
                      {matchweeks.map((ele, i) => {
                        let color = COLOR_RATING.find((color) => color.id === ele?.difficulty_rating);

                        return (
                          <td
                            key={i}
                            className="text-center text-green-500  px-2 py-2 w-20"
                          >
                            <span style={{ background: color?.colorCode }} className={`bg-gray-800 text-[${color.textColor}] w-16 h-8  
                              flex justify-center ml-4 items-center
                              
                              `}>{ele?.opponent_code || "-"}({ele.venue})</span>

                          </td>
                        );
                      })}

                      <td className="w-8"></td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={difficultyMatchInfo?.matchweeksHeader?.length + 3} className="text-center py-8">
                    <p className="text-gray-500">
                      No Data on difficulty rating
                    </p>
                  </td>
                </tr>
              )}
            </tbody>

          </table>

          {showDropdown && (
            <div
              ref={dropdownRef}
              className="absolute top-12 left-4 z-20 bg-white border border-gray-300 shadow-lg rounded-md w-28"
            >
              <ul className="text-sm text-gray-700">
                {FilterDropDown.map((ele) => (
                  <li
                    key={ele.id}
                    className="px-4 py-2 hover:bg-blue-100 hover:text-blue-600 cursor-pointer"
                    onClick={() => {
                      setSelectedFilter(ele.title);
                      setShowDropdown(false);
                    }}
                  >
                    {ele.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
      {/* <div className="sticky top-0 z-20 bg-white">
        <img src={PitchImage} alt="Pitch" className="w-full h-full object-cover rounded-b-lg" />
        <GlassSlider active={active} setSelected={setSelected} />
      </div> */}
      {/* </div> */}


    </div>
  );
}

export default DifficultyRating;
